module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg15.46eacd59.jpg";